import { render, staticRenderFns } from "./MailProgressionTab.vue?vue&type=template&id=626449e8&scoped=true&"
import script from "./MailProgressionTab.vue?vue&type=script&lang=js&"
export * from "./MailProgressionTab.vue?vue&type=script&lang=js&"
import style0 from "./MailProgressionTab.vue?vue&type=style&index=0&id=626449e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626449e8",
  null
  
)

export default component.exports